var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.6895 17.6173C43.2904 9.83928 35.5289 4.40434 26.5 4.40434C17.47 4.40434 9.70849 9.83928 6.31055 17.6173",
    stroke: "white",
    strokeWidth: 4.40433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5001 15.4152C24.4053 17.4632 22.7417 19.9098 21.6071 22.6107C20.4725 25.3117 19.8898 28.2124 19.8936 31.1419C19.8936 31.6925 19.9134 32.2386 19.9541 32.7803C22.0309 34.8264 23.6793 37.2656 24.8031 39.9555C25.927 42.6455 26.5039 45.5323 26.5001 48.4477C26.4961 45.5322 27.0729 42.6451 28.1968 39.9549C29.3207 37.2648 30.9692 34.8254 33.046 32.7792C33.2888 29.5825 32.8286 26.3715 31.6977 23.3716C30.5668 20.3718 28.7927 17.656 26.5001 15.4152V15.4152Z",
    stroke: "white",
    strokeWidth: 4.40433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.47852 26.426C4.47852 38.5886 14.3376 48.4477 26.5002 48.4477C26.5041 45.5322 25.9274 42.6451 24.8035 39.9549C23.6796 37.2648 22.0311 34.8254 19.9542 32.7793C15.8365 28.7018 10.2735 26.418 4.47852 26.426V26.426Z",
    stroke: "white",
    strokeWidth: 4.40433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5217 26.426C48.5217 38.5886 38.6626 48.4477 26.5 48.4477C26.496 45.5322 27.0728 42.6451 28.1967 39.9549C29.3206 37.2648 30.9691 34.8254 33.046 32.7793C37.1637 28.7018 42.7267 26.418 48.5217 26.426V26.426Z",
    stroke: "white",
    strokeWidth: 4.40433,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkWhite);
export default __webpack_public_path__ + "static/media/parkWhite.64dd706fc9603e226bcd6fea8401f5fa.svg";
export { ForwardRef as ReactComponent };